<script>
import fileMixins from '@/components/Mixins/FileMixins'
export default {
  mixins: [fileMixins],
  data() {
    return {
      item: {},
      submitItem: {},
      chooseItem: {
        syncTicketLength: 0,
        syncAnnexLength: 0
      },
      inside: true,
      isSubmit: false,
      submitForm: {
        syncTicketResultList: [],
        syncCheckAnnexIdsList: []
      },
      syncTicketLength: 0,
      syncAnnexLength: 0,
      ticketImgsList: [], // 发票图片列表
      annexImgsList: [] // 结算确认单列表
    }
  },
  methods: {
    initSubmitMixins() {
      this.submitItem = {}
      this.chooseItem.syncTicketLength = 0
      this.chooseItem.syncAnnexLength = 0
      this.inside = true
      this.isSubmit = false
      this.submitForm = {
        syncTicketResultList: [],
        syncCheckAnnexIdsList: []
      }
      this.syncTicketLength = 0
      this.syncAnnexLength = 0
      this.ticketImgsList = []
      this.annexImgsList = []
    },
    // 初始化列表
    initList() {
      this.getToken({
        dataGroupOrgId: this.item.settlementSubmitContracts[0].dataGroupOrgId,
        domainUserCode: this.item.settlementSubmitContracts[0].domainUserCode
      }).then(() => {
        // 发票
        this.initInvoImgs()
        // 结算确认单
        this.initConfirmImgs()
        return
      })
    },
    // 初始化发票文件信息等
    initInvoImgs() {
      this.chooseItem.syncTicketLength = this.item.settlementInvoiceList.length // 发票长度
      this.getInvoImgs(this.item.settlementInvoiceList)
      // const arr = []
      // this.item.settlementInvoiceList.forEach(item => {
      //   // 如果未成功 则放入数组中
      //   if (item.status !== 1) {
      //     arr.push(item)
      //   }
      // })
      // this.chooseItem.syncTicketLength = arr.length
      // this.getInvoImgs(arr)
    },
    // 从服务器获取发票图片并进行组装
    getInvoImgs(invoList) {
      this.ticketImgsList = []
      let tag = 0
      let flag = 0
      invoList.forEach(ele =>{
        if(ele.status!==1){
          flag++
        }
      })
      invoList.forEach((item, index) => {
        if(item.status!==1){
          // this.ticketImgsList.push({})
          this.getImgFn(item.id).then(img => {
            // const url = window.URL.createObjectURL(img)
            // const name = decodeURI(img.name)
            this.ticketImgsList.push({
              img, // 图片文件
              // name, // 名称
              Attachment: '',
              Base64Images: '',
              status: item.status
            })
            tag ++
            if (tag === flag) {
              // 对发票文件集合进行循环转换base64后并上传
              this.filterInvoList()
            }
          })
        }
      })
      
    },
    // 初始化结算单
    initConfirmImgs() {
      // 判断是否上传了结算确认单
      if (this.item.settlementAnnexes.length > 0) {
        const confirmList = this.item.settlementAnnexes
        this.chooseItem.syncAnnexLength = this.item.settlementAnnexes.length // 确认单长度
        // 结算单进行组装
        let tag = 0
        confirmList.forEach((item, index) => {
          this.annexImgsList.push({})
          this.getImgFn(item.id).then(img  => {
            const url = window.URL.createObjectURL(img)
            const name = decodeURI(img.name)
            this.annexImgsList[index]= {img, name}
            tag ++
            if (tag === this.item.settlementAnnexes.length) {
              this.submitConfirme().then(res => {
                const data = res.data
                if (res.status === 200 && res.data) {
                  if (res.data.isValid) {
                    this.checkSubimtAnnex(res.data.imageSystemReturnResponses)
                  } else {
                    this.alert(res.data.errorMessages)
                  }
                } else {
                  this.alert('结算单上传失败')
                }
              })
            }
          })
        })
      } else {
        this.isChecked.checkAnnex = true
      }
    },
    close() {
      this.$emit('close')
    }
  },
  watch: {
    item() {
      if (this.item) {
        this.initList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: 0;
  span {
    font-weight: bold;
    font-size: 1rem;
  }
}
.img-box {
  width: 200px;
  height: 200px;
  position: relative;
  margin-right:  20px;
  margin-bottom: 10px;
  img {
    width: 200px;
    height: 200px;
  }
  .progress {
    position: absolute;
    top: 50%;
    width: 100%;
  }
}
</style>